import { Autocomplete, Grid, Popover, TextField } from "@mui/material";
import { formatArray } from "lib/arrayObject";
import { isEmpty } from "lodash";
import { getPies } from "models/piesModel";
import React, { useEffect, useState } from "react";
import PieAddCard from "./PieAddCard";

export default function PieGrid({
  data: propsData = [],
  onChange = () => {},
  onError = () => {},
}) {
  const [data, setData] = useState(Array.from({ length: 8 }, (v, i) => false));
  const [selected, setSelected] = useState({ index: -1 });
  const [pies, setPies] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isSelected = selected?.index >= 0;
  const layout = Array.from({ length: 8 }, (v, i) => ({
    index: i,
    isEmpty: !data?.[i],
    data: data?.[i] ?? {},
  }));

  const handleSelect = (value = {}, valueIndex = -1) => {
    setSelected({ index: valueIndex, data: value });
  };

  const handleAdd = (value = {}, valueIndex = -1, values = []) => {
    setData((s = []) => {
      const newData = [
        ...formatArray(s).slice(0, selected?.index),
        value,
        ...formatArray(s).slice(selected?.index + 1),
      ];
      onChange(newData);
      onError(
        newData.filter((item) => item).length < 8
          ? { pies: "select all" }
          : { pies: "" }
      );
      return newData;
    });
    setSelected({ index: -1 });
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelected({ index: -1 });
  };

  useEffect(() => {
    if (!isEmpty(propsData)) {
      setData(propsData);
    }
  }, [propsData]);

  useEffect(() => {
    getPies({
      onFinish: (res = []) => {
        setPies(res ?? []);
      },
    });
  }, []);

  return (
    <div className="relative">
      <Grid container spacing={2} justifyContent="space-between" columns={24}>
        {layout.map((pie, pieIndex, self) => {
          const disabled = isSelected && pieIndex !== selected?.index;
          return (
            <Grid key={pieIndex} item lg={3} md={6} sm={12} xs={12}>
              <div className="relative h-full">
                <PieAddCard
                  disabled={disabled}
                  pieIndex={pieIndex}
                  onClick={(event) => {
                    handleSelect(pie, pieIndex);
                    setAnchorEl(event.currentTarget);
                  }}
                  data={pie}
                />
                <Popover
                  // id={id}
                  sx={{ boxShadow: "none", marginTop: 1 }}
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <Autocomplete
                    disableClearable={true}
                    size="small"
                    className="w-60"
                    sx={{ background: "#fff" }}
                    options={pies}
                    getOptionLabel={(option) => option.name ?? ""}
                    value={selected?.data?.data ?? {}}
                    onChange={(event, newValue) => handleAdd(newValue)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Popover>
              </div>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}
